module.exports = __webpack_public_path__ + "static/media/dashboard-interface.d32c6f85.svg";